import { Images } from '../../../utils/imageConstants';
import { useAppDispatch } from '../../../redux/hooks';
import { openAuth } from '../../../redux/slice/authModalSlice';

function MyTeamGuestState() {
  const dispatch = useAppDispatch();

  const handleSignIn = () => {
    dispatch(openAuth('signin'));
  };

  return (
    <div className="myteam-empty-state">
      <div className="myteam-empty-illustration">
        <img src={Images.my_leagues_no} alt="" className="myteam-empty-logo" />
      </div>
      <p className="myteam-empty-message">Please sign in to view and manage your teams.</p>
      <button type="button" className="myteam-empty-cta" onClick={handleSignIn}>
        Sign in
      </button>
    </div>
  );
}

export default MyTeamGuestState;
